import React from 'react';

const HomeContent = () => (
  <p className='paragraph'>
    Apresentando "DIM" (Dimensão Medieval), uma banda de metal em ascensão que combina habilmente a potência do metal com as melodias atemporais da música medieval. Com uma formação que abrange várias dimensões musicais, eles trilharam um caminho para criar uma experiência sonora única.
  </p>
);

export default HomeContent;